"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const store_1 = __importDefault(require("store"));
const app_component_1 = __importDefault(require("pages/app.component"));
const sw_1 = __importDefault(require("./sw"));
require("@progress/kendo-theme-default/dist/all.css");
require("assets/css/kendo.css");
require("assets/css/root.css");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const timeZoneNames_json_1 = __importDefault(require("cldr-dates-full/main/en-AE/timeZoneNames.json"));
const dateFields_json_1 = __importDefault(require("cldr-dates-full/main/en-AE/dateFields.json"));
const ca_gregorian_json_1 = __importDefault(require("cldr-dates-full/main/en-AE/ca-gregorian.json"));
const weekData_json_1 = __importDefault(require("cldr-core/supplemental/weekData.json"));
const numbers_json_1 = __importDefault(require("cldr-numbers-full/main/en-AE/numbers.json"));
const currencies_json_1 = __importDefault(require("cldr-numbers-full/main/en-AE/currencies.json"));
const currencyData_json_1 = __importDefault(require("cldr-core/supplemental/currencyData.json"));
const likelySubtags_json_1 = __importDefault(require("cldr-core/supplemental/likelySubtags.json"));
(0, kendo_react_intl_1.load)(weekData_json_1.default, ca_gregorian_json_1.default, dateFields_json_1.default, timeZoneNames_json_1.default, numbers_json_1.default, currencies_json_1.default, currencyData_json_1.default, likelySubtags_json_1.default);
const Root = () => {
    return ((0, jsx_runtime_1.jsx)(react_redux_1.Provider, Object.assign({ store: store_1.default }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.HashRouter, { children: (0, jsx_runtime_1.jsx)(kendo_react_intl_1.IntlProvider, Object.assign({ locale: 'en-AE' }, { children: (0, jsx_runtime_1.jsx)(app_component_1.default, {}) })) }) })));
};
const rootEl = document.getElementById('root');
(0, sw_1.default)();
react_dom_1.default.render((0, jsx_runtime_1.jsx)(Root, {}), rootEl);
